import { render, staticRenderFns } from "./tag-list.vue?vue&type=template&id=b92d64e0&scoped=true&"
import script from "./tag-list.vue?vue&type=script&lang=js&"
export * from "./tag-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92d64e0",
  null
  
)

export default component.exports